import React from 'react';
import { DeskDay } from "./DeskAvailability";
import { CapacityResponse } from '@features/desks/services/OfficeCapacityService';
import { OfficeUsageWithHalfSpace, WithOfficeCapacity } from "../../../weekly-movements-setter/hooks/WithCapacity";

export function NumberOfDesksAvailableIndicator(props: Props) {
  const {deskUsage} = props;
  const availableSpaces = WithOfficeCapacity(deskUsage);
  return (
    <>
      <DeskDay title={deskUsage.date}>
        <div className="userRow__desks__number">
          <OfficeUsageWithHalfSpace availableSpaces={availableSpaces} />
        </div>
      </DeskDay>
    </>
  )
}

interface Props {
  deskUsage: CapacityResponse;
}
